// eslint-disable-next-line @rushstack/typedef-var -- disable scoped to legacy integration boundary in this file
export const translation = {
    common: {
        cancel: 'Abbrechen',
        delete: 'Löschen',
        finished: 'Abgeschlossen',
        yesContinue: 'Ja, weiter',
        loading: 'Lade',
        settings: 'Einstellungen',
        save: 'Speichern',
        remove: 'Entfernen',
        ok: 'Ok',
        error: 'Unbekannter Fehler',
        yesRemove: 'Ja, entfernen',
        language: 'Sprache',
        appearance: 'Darstellung',
        themeSystem: 'System',
        themeLight: 'Hell',
        themeDark: 'Dunkel',
        beta: 'Beta',
        themeDarkBetaHint: 'Der Dunkelmodus befindet sich noch in der Beta-Phase und kann kleinere visuelle Unstimmigkeiten enthalten.',
        back: 'Zurück',
        history: 'Historie',
        errorValidation: 'Validierung fehlgeschlagen',
        description: 'Beschreibung',
        action: 'Aktion',
        system: 'System',
        apiUser: 'API Nutzer',
        unknownUser: 'Unbekannt Nutzer',
        brand: 'Marke',
        tableOfContentsText: 'Inhaltsverzeichnis Text',
        confirm: 'Bestätigen',
    },
    historyEntryDescriptions: {
        historyPostImportDisclaimer: 'Die Informationen zu Statusänderungen in der Spalte "Beschreibung" (z. B. „Draft” > „Publish”) im History-Tab für diesen Artikel können unvollständig sein. Dies betrifft die Einträge im Zeitraum vom 5. bis 10. Juli 2025',
        authorMerged: 'Autoren zusammenführen',
        scheduledChangeApplied: 'Geplante Änderung angewendet',
        scheduledChangeCreated: 'Geplante Änderung erstellt',
        scheduledChangeUpdated: 'Geplante Änderung aktualisiert',
        scheduledChangeDeleted: 'Geplante Änderung gelöscht',
        createDate: 'Erstellungsdatum: {date}',
        firstPublishedDate: 'Erstveröffentlichungsdatum: {date}',
        abTestStarted: 'A/B-Headline-Test gestartet',
        abTestStoppedByEditor: 'A/B-Headline-Test gestoppt',
        abTestCompleted: 'A/B-Headline-Test abgeschlossen',
        abTestCompletedNoWinner: 'A/B-Headline-Test abgeschlossen - kein Gewinner',
        abTestStartFailed: 'Der A/B-Headline-Test konnte nicht gestartet werden. Er wird automatisch wiederholt.',
        abTestPollFailed: 'Das A/B-Headline-Test-Ergebnis konnte nicht abgerufen werden. Der Abruf wird automatisch wiederholt.',
    },
    router: {
        createImage: 'Bild hochladen',
        editImage: 'Bild bearbeiten',
        createPerson: 'Person erstellen',
        editPerson: 'Person bearbeiten',
        createGallery: 'Galerie erstellen',
        editGallery: 'Galerie bearbeiten',
        createPage: 'Seite erstellen',
        editPage: 'Seite bearbeiten',
        createRedirect: 'Weiterleitung erstellen',
        editRedirect: 'Weiterleitung bearbeiten',
        createToplink: 'Toplink erstellen',
        editToplink: 'Toplink bearbeiten',
        createCustomer: 'Kunde erstellen',
        editCustomer: 'Kunde bearbeiten',
        whitelist: 'Whitelist-Domains',
        createWhiteListLink: 'WhiteList Link Erstellen',
    },
    navigation: {
        hello: 'Hallo',
        logout: 'Ausloggen',
        minimize: 'Minimieren',
        articles: 'Artikel',
        channels: 'Channel-Seiten',
        channelizer: 'Channelizers',
        images: 'Bilder',
        galleries: 'Galerien',
        videos: 'Videos',
        people: 'People',
        authors: 'Autoren',
        users: 'Nutzer',
        additiveRights: 'Zusatzrechte',
        pages: 'Seiten',
        staticPages: 'Statische Seiten',
        homeAndChannels: 'Homes & Channels',
        whiteList: 'Whitelist-Domains',
        userManagement: 'Nutzer-Management',
        noPermission: 'Du hast keinen Zugriff auf diese Seite.',
        authorProfile: 'Autorenprofil',
        listArticles: 'Listen',
        linkoutTeasers: 'Linkout-Teaser',
        menuTree: 'Menübaum',
        tools: 'Werkzeuge',
        authorMerge: 'Autoren zusammenführen',
        bfJobGroups: 'Teams',
        seoWhiteList: 'Whitelist-Domains',
        linksBox: 'Partner-Linkboxen',
        apiTeaser: 'API-Teaser',
        apiUsers: 'API Nutzer',
        testreportGenerator: 'Testbericht-Generator',
        permissions: {
            viewOnly: {
                label: 'Nur ansehen',
                hover: 'Du kannst keine Elemente hinzufügen, ändern oder entfernen.',
            },
        },
        moduleExamples: {
            _title: 'Modulbeispiele',
            complexModule: 'Komplexes Modul',
            complexPage: 'Komplexe Seite',
            externalTool: 'Externe Anwendungen',
        },
        externalContent: {
            _title: 'Externe Contents',
            partnerContent: 'Partner',
            agencyContent: 'Agenturen',
            expertsContent: 'Experten',
        },
        partnerManagement: {
            _title: 'Partner-Management',
        },
        assemblerCategories: 'Partner-Kategorien',
        assemblerFeeds: 'Partner-Feeds',
        partners: 'Partner',
        catTool: 'CAT',
        aissist: 'AISSIST',
        widgets: {
            _title: 'Widgets',
        },
        articlesBox: 'Interne Linkboxen',
        articlePush: 'Pushes',
        ctaButton: 'CTA-Buttons',
        inpageWidget: 'Externer-Code-Widgets',
        tags: 'Tags',
        hubPages: 'Hub-Pages',
        tagEntities: 'Entitäten',
        reusableText: 'Textboxen',
        redirect: 'Redirects',
        newsletterWidgets: 'Newsletter-Widgets',
        recipe: 'Rezepte',
        videoPage: 'Video-Seiten',
        finanzen100ChartWidgets: 'Börsenkurs-Widgets',
        abHeadlineTest: 'A/B-Headline-Tests',
        profile: 'Profil',
        reportProblem: 'Problem melden',
        movies: 'Filme',
    },
    login: {
        login: 'Login',
        pwLostTitle: 'Passwort vergessen?',
        pwLostText: 'Keine Sorge! Gib einfach deine Email Adresse ein und wir senden dir eine Mail mit den notwendigen Schritten, um ein neues Passwort auszuwählen.',
        fieldEmail: 'E-Mail',
        fieldPassword: 'Passwort',
        twoFactorToken: '2 Faktor Token',
        alreadyAccountText: 'Noch keinen Account?',
        alreadyAccountLink: 'Jetzt anfragen.',
        sendEmail: 'Email senden',
        backToLogin: 'Zurück zum Login',
        instructionsSent: 'Instruktionen gesendet',
        checkEmail: 'Bitte checke dein Emailpostfach um dein Passwort zurückzusetzen.',
        sessionExpired: 'Sitzung abgelaufen. Bitte erneut einloggen.',
        wrongEmail: 'Email und Passwort sind nicht korrekt',
        wrongToken: 'Token ist nicht korrekt',
        mailtoAccountSubject: 'Zugang zum BurdaForward-Editor',
        mailtoAccountBody: 'Liebes Editor-Team,%0D%0Aich bin neu bei BurdaForward und benötige bitte Zugriff zum Editor. Meine E-Mail ist: &lt;insert email&gt;.%0D%0AViele Grüße',
    },
    articleApi: {
        pathExists: 'Artikel mit diesem Pfad (SEO-Zeile) existiert bereits',
        notFound: 'Artikel nicht gefunden',
        updated: 'Artikel aktualisiert',
        created: 'Artikel erstellt',
        outdated: 'Artikeldaten sind veraltet. Aktualisierung fehlgeschlagen',
    },
    articles: {
        backToList: 'Zurück zur Artikelliste',
        settings: 'Einstellungen',
        content: 'Inhalt',
        preview: 'Vorschau',
        basics: 'Basics',
        saveKeepPublished: 'Speichern & veröffentlicht lassen',
        savePublish: 'Veröffentlichen',
        saveScheduled: 'Veröffentlichung planen',
        saveOffline: 'Artikel offline nehmen',
        saveDraft: 'Als Entwurf speichern',
        deleteArticle: 'Artikel löschen',
        messagePublishTitle: 'Artikel veröffentlichen',
        messagePublish: 'Bist du sicher, dass du den Artikel veröffentlichen möchtest?',
        messageUnpublishTitle: 'Artikel offline nehmen',
        invalidOperation: 'Ungültiger Vorgang',
        backToArticle: 'Zurück zum Artikel',
        messageAutoImageTitle: 'Bilder automatisch importieren',
        messageAutoImage: 'Möchtest du das Teaserbild und weitere Bilder automatisch importieren?',
        messageAutoImageConfirm: 'Ja, importieren',
        messageAutoImageCancel: 'Nein',
        messageDeleteArticleTitle: 'Artikel löschen',
        messageDeleteArticle: 'Bist du dir sicher, dass du den Artikel löschen möchtest?',
        messageConfirmUnpublishArticle1: 'Bist du sicher, dass du den Artikel',
        messageConfirmUnpublishArticle2: 'offline nehmen möchtest?',
        messageConfirmDraftArticle2: 'als entwurf speichern möchtest?',
        errorPreventSaveAsDraft: 'Du kannst einen Artikel nicht als Entwurf speichern, wenn ein Veröffentlichungsdatum festgelegt ist. Bitte setze die Box auf "Kein Veröffentlichungsdatum" oder klicke auf "Speichern & Veröffentlichen".',
        errorMandatoryFields: 'Entschuldigung, du kannst den Artikel nicht speichern, weil nicht alle Pflichtfelder ausgefüllt sind',
        errorAMPValidation1: 'Artikel ',
        errorAMPValidation2: 'wurde aktualisiert aber die AMP Validierung ist fehlgeschlagen.',
        messageArticleDeleted: 'Artikel gelöscht',
        modeUnpublished: 'Offline genommen',
        modeScheduled: 'Veröffentlichung geplant',
        modePublished: 'Veröffentlicht',
        modeDraft: 'Entwurf',
        removeArticle: 'Artikel anzeigen',
        versions: 'Versionen',
    },
    articlesSettings: {
        leadText: 'Vorspann',
        peopleInArticle: 'Personen im Artikel',
        backgroundArticles: 'Mehr zum Thema - Artikel',
        adArticle: 'Artikel wird als Anzeige markiert',
        adsEnabled: 'Werbung aktiviert',
        ampEnabled: 'AMP aktiviert',
        hideFromNewsticker: 'Nicht im newsticker anzeigen',
        hideFromTeaserList: 'Nicht im teaser listing anzeigen',
        checkValidation: 'Validierung prüfen',
        msn: 'MSN Service',
        magazine: 'Inhalt aus dem BUNTE-Magazin',
        adTags: 'Werbetags',
        weight: 'Wichtigkeit',
        showPartnerLogo: 'Partnerlogo anzeigen',
        isBought: 'Artikel gekauft',
        seoUrlSettings: 'URL & SEO',
        canonicalUrl: 'Canonical URL',
        unknownCanonicalUrl: 'Unbekannt - Wird bei Veröffentlichung aktualisiert',
        missingCanonicalUrl: 'Fehlt - Kontaktiere bitte CTF, wenn das Problem besteht',
        noIndex: 'NoIndex aktivieren',
        toArticle: 'Zum Artikel',
        author: 'Autor',
        createdBy: 'Erstellt von',
        messageAMPSuccess: 'AMP Validierung war erfolgreich',
        messageAMPFailed: 'AMP Validierung fehlgeschlagen',
        messageAMPFailedMandatory: 'AMP Validierung fehlgeschlagen weil nicht alle Pflichtfelder ausgefüllt sind',
        messagePreviewTitle: 'Artikel nicht gespeichert',
        messagePreview: 'Um die Artikelpreview zu sehen, musst du den Artikel erst speichern.',
        messagePreviewCancel: 'Ok',
        messageNotSavedTitle: 'Nicht gespeicherte Änderungen',
        messageNotSaved: 'Um den Artikel zu öffnen und deine Änderungen zu sehen, musst du die Änderungen erst speichern.',
        messageNotSavedCancel: 'Zurück zum Editor',
        messageNotSavedButton: 'Trotzdem öffnen',
        bfJobTitle: 'Jobteam',
        source: 'Quelle',
        showMostReadArticles: 'Zeige die Meistgelesen-Stage',
        general: 'Allgemein',
        originalSourceUrl: 'Kuratierte URL',
    },
    articlesList: {
        title: 'Artikel',
        newButton: 'Neuer Artikel',
        multiLabel: 'Ausgewählte Artikel speichern',
        search: 'Nach Hauptzeile oder Vorzeile suchen',
        myArticles: 'Meine Artikel',
        includeSubchannels: 'Subchannel miteinbeziehen',
        statusDropdown: 'Status',
        statusAll: 'Alle',
        statusDraft: 'Entwurf',
        statusSchedule: 'Geplant',
        statusPublished: 'Veröffentlicht',
        statusUnpublish: 'Depubliziert',
        typeDropdown: 'Typ',
        typeAll: 'Alle',
        typeImages: 'Bilder',
        typeVideos: 'Videos',
        typeGalleries: 'Galerien',
        displayDateFrom: 'Zeige von',
        displayDateTo: 'Zeige bis',
        displayPeriod: 'Zeitraum',
        isPremium: 'Nur Premiumartikel',
        isBought: 'Artikel gekauft',
        contentPartner: 'Content Partner',
        loading: 'Lade Artikel',
        deleteArticle: 'Artikel löschen',
        headerStatus: 'Status',
        headerKickerTitle: 'Vorzeile, Hauptzeile',
        headerChannel: 'Channel',
        headerPublished: 'Veröffentlicht',
        headerChanged: 'Geändert',
        headerAMP: 'AMP',
        headerAMPDescription: 'Grüner Haken: Die AMP-Version des Artikels ist valide. Damit funktioniert er auf allen Google-Plattformen.\nRotes Kreuz: Der Artikel enthält Elemente, welche die AMP invalidieren. Bitte nochmals prüfen.',
        multiSelect: 'Auswählen',
        dpEdit: 'Bearbeiten',
        dpGoToArticle: 'Zum Artikel',
        dpDelete: 'Artikel löschen',
        messageNoSelfLink: 'Artikel kann nicht auf sich selbst verlinken',
        messageDelete1: 'Bist du sicher, dass du den Artikel',
        messageDelete2: 'löschen willst?',
        messageDeleteSuccess: 'Artikel gelöscht',
        openInNewTab: 'In neuem Tab öffnen',
        isRenderedByCTF: 'Gerendert von CTF',
        hasBeenModifiedInCTF: 'Geändert in Vibe',
        isEditableInCTF: 'Bearbeitbar in Vibe',
    },
    articlesEdit: {
        kicker: 'Vorzeile',
        title: 'Hauptzeile',
        people: 'Personen',
        leadText: 'Vorspann',
        words: 'Wörter',
        chars: 'Buchstaben',
        addContent: 'Element hinzufügen',
        remove: 'Entfernen',
        externalSource: 'Externe Quelle',
        excludedSources: 'Ausgeschlossene externe Artikelquelle',
        channel: 'Channel',
        articleTitle: 'Artikel Titel',
        seoTitle: 'SEO-Zeile',
        articleType: 'Artikel-Typ',
        image: 'Bild',
        video: 'Video',
        gallery: 'Galerie',
        imageSelector: 'Hauptbild auswählen oder hochladen',
        videoSelector: 'Hauptvideo auswählen',
        mainImageTitle: 'Hauptbild',
        teaserVideoTitle: 'Vorschaubild',
        teaserImageTitle: 'Teaserbild',
        mainImageTitleTooltip: 'Das Hauptbild wird auf der Artikelseite angezeigt.',
        mainVideoTitleTooltip: 'Das Hauptvideo wird auf der Artikelseite angezeigt.',
        teaserVideoTitleTooltip: 'Das Hauptvideo wird auf der Artikelseite angezeigt.',
        differentTeaser: 'Anderer Teaser und A/B-Headline-Test',
        differentTeaserTooltip: 'Anderer Teaser (Vorzeile, Hauptzeile, Vorspann) für Home und Channel-Seiten oder Kurztitel für platzreduzierte UI-Elemente',
        teaserImageTitleTooltip: 'Das Teaserbild wird auf Channelseiten angezeigt. Wenn kein Teaserbild vorhanden ist, wird das Hauptbild auf Channelseiten benutzt.',
        teaserImageSelector: 'Teaserbild auswählen oder hochladen (optional)',
        teaserInfo: 'Wenn kein Teaserbild vorhanden ist, wird das Hauptbild auf Channelseiten benutzt',
        teaserInfoVideo: 'Wenn kein Teaserbild vorhanden ist, wird das Videobild auf Channelseiten benutzt',
        setAsDefault: 'Für Artikel übernehmen',
        articleTab: 'Artikel',
        teaserTab: 'Teaser',
        shortTitleTab: 'Kurztitel',
        shortTitle: 'Kurztitel',
        shortTitleHelper: 'Ein optionaler kürzerer Titel zur Darstellung in platzreduzierten UI‑Elementen.',
        gallerySelector: 'Galeriebild',
        teaserGalleryTitle: 'Teaserbild',
        teaserGalleryMainImageTitle: 'Hauptbild',
        teaserGalleryMainImageLabel: 'Hauptbild auswählen oder hochladen',
        teaserGalleryMainImageCheckbox: 'Zur Galerie hinzufügen',
        teaserGalleryMainImageCheckboxTooltip: 'Das Hauptbild wird der gewählten Galerie hinzugefügt.',
        gallerySelectorTooltip: 'Das Galeriebild wird auf der Artikelseite angezeigt.',
        teaserGalleryMainImageTitleTooltip: 'Das Hauptbild ist optional.',
        teaserImageGallery: 'Teaserbild auswählen oder hochladen',
        dateSettingsTitle: 'Veröffentlichung',
        showFirstPublishDate: 'Erstveröffentlichungsdatum anzeigen',
        videoAutoplay: 'Autoplay',
        videoSpotted: 'Spotted Video',
        videoSpottedTooltip: 'Wähle "Spotted Video" für Video-First-Artikel, in denen das Video der Hauptcontent ist. Der Content wird im Teaser als "Video" markiert. Ist die Option “Spotted Video” deaktiviert, so handelt es sich um ein Performance-Video, welches im Teaser als Text "Mit Video" markiert wird.',
        articleDisplayDate: 'Angezeigtes Datum',
        noPublishDate: 'Veröffentlichung terminieren',
        setPublishDate: 'Veröffentlichen am',
        setUnpublishDate: 'Offline nehmen am',
        relatedDeleted: 'Gelöscht',
        relatedExpired: 'Abgelaufen',
        relatedWeight: 'Wichtigkeit',
        relatedRemove: 'Entfernen',
        relatedPlaceHere: 'Artikel hier platzieren',
        relatedPrioAd: 'AD',
        relatedPrioInside: 'LOGIN',
        relatedArticleAdd: 'Artikel verlinken',
        seoPerfect: 'Perfekte Länge',
        seoOkay: 'In Ordnung, kürzen wenn möglich',
        seoLong: 'Zu lang, bitte kürzen!',
        desktopAlertTitle: 'Es ist ein Fehler aufgetreten',
        desktopAlertDescription: 'Deine Auflösung ist aktuell zu gering, um die Desktop Vorschau anzuzeigen.<br/>Bitte minimiere das Menü auf der linken Seite, um das Anzeigen zu ermöglichen.',
        addPeople: 'Personen verlinken',
    },
    articleBlocks: {
        ctaLayout: 'Layout',
        ctaButton: 'Button',
        ctaStickyButton: 'Sticky Button',
        ctaBox11: 'Box 1:1',
        ctaBox11Info: 'Box mit Bild im 1:1 Format',
        ctaBox169: 'Box 16:9',
        ctaBox169Info: 'Box mit Bild im 16:9 Format',
        ctaTitle: 'Titel',
        ctaButtonText: 'Button Text (17 Zeichen Limit)',
        ctaLink: 'Button Link',
        ctaIsAffiliate: 'Zeige Affiliate-Disclaimer',
        noFollow: 'No Follow',
        noFollowTooltip: "Der Link wird als 'nofollow' gekennzeichnet. Bitte für werbliche Links immer nofollow auswählen.",
        blockTeaser: 'Article Teaser',
        imageUrl: 'Bild-URL',
        imagePlaceholder: 'Link URL, muss mit https:// starten',
        videoPlaceholder: 'Video auswählen',
        videoTeaser: 'Video Teaser',
        hasAffiliate: 'Affiliate-Link',
        hasAffiliateTooltip: 'Ist ein Link als Affiliate-Link gekennzeichnet, erscheint am Anfang des Artikels die Affiliate Disclaimer-Box und das Element wird als Anzeige markiert.',
        newTab: 'In neuem Tab öffnen',
        bound: 'Bündig',
        boundTooltip: 'Per default ist der Banner freigestellt und nicht bündig mit dem nachfolgendem Block.',
        becomeInsider: 'INSIDER werden und direkt weiterlesen',
        loginwallText: 'Nutzer können sich hier registrieren um mehr Inhalte zu sehen. Eingeloggten Benutzern wird dieses Element nicht angezeigt.',
        quoteAuthor: 'Zitat von',
        scriptBlock: 'Benutzerdefiniertes JavaScript einfügen (wird nicht auf AMP angezeigt). Bitte Auswirkungen auf DSGVO beachten.',
        rawBlock: 'Benutzerdefiniertes JavaScript einfügen (auf AMP angezeigt). Bitte Auswirkungen auf DSGVO beachten.',
        highlightBox: 'Highlight Box',
        labelText: 'Text',
        labelImage: 'Bild',
        labelGallery: 'Galerie',
        labelVideo: 'Video',
        labelArticle: 'Artikel',
        labelPaywall: 'Paywall',
        labelLoginwall: 'Login',
        labelSocial: 'Social',
        labelQuote: 'Zitat',
        labelCTA: 'Call to Action',
        labelNewsletter: 'Newsletter Box',
        or: 'ODER',
        imageLink: 'Alternativ: Bild per Link einfügen',
        imageUrlStart: 'Bild-URL, muss mit https:// starten',
        imagePreview: 'Vorschau',
    },
    articlesVersions: {
        noVersions: 'Keine Version verfügbar',
        unknownEditor: 'Unbekannter Autor',
        modifiedBy: 'Geändert von',
        modifiedAt: 'Geändert am',
    },
    authorsApi: {
        createAlreadyExists: 'Autor konnte nicht erstellt werden. Ein Autor mit diesem Namen existiert bereits',
        updateAlreadyExists: 'Autor konnte nicht aktualisiert werden. Ein Autor mit diesem Namen existiert bereits',
        created: 'Autor erstellt',
        updated: 'Autor aktualisiert',
        notFound: 'Autor nicht gefunden',
    },
    authorsList: {
        title: 'Autoren',
        newButton: 'Neuer Autor',
        name: 'Nach Name suchen',
        status: 'Status',
        statusActive: 'Aktiv',
        statusInactive: 'Inaktiv',
        loading: 'Lade Autoren',
        headerStatus: 'States',
        headerName: 'Anzeigename',
        headerCreatedAt: 'Erstellt am',
        messageActive: 'Autor aktiv',
        messageInactive: 'Autor geblockt',
        dpEdit: 'Bearbeiten',
        disableAllBrands: 'Alle Marken deaktivieren',
        activateAllBrands: 'Alle Marken aktivieren',
    },
    authors: {
        backButton: 'Zurück zur Autorenliste',
        displayName: 'Anzeigename',
        jobTitle: 'Jobtitel',
        biography: 'Biografie',
        xing: 'Xing-URL',
        linkedin: 'LinkedIn-URL',
        twitter: 'X-URL (Ex-Twitter)',
        facebook: 'Facebook-URL',
        instagram: 'Instagram-URL',
        tiktok: 'Tiktok-URL',
        email: 'E-mail',
        settings: 'Einstellungen',
        active: 'Aktiv',
        showArticles: 'Zeige Artikel',
        vgWort: 'VG-Wort-Nummer (Karteinummer)',
        profileUrl: 'Autorenprofil URL',
        path: 'Pfad',
        pathPlaceholder: 'Wird automatisch ausgefüllt',
        toAuthorProfile: 'Zum Autorenprofil',
        messageMandatoryInfo: 'Du kannst den Autor noch nicht speichern, da benötigte Informationen fehlen.',
        messageUpdated: 'Autor aktualisiert',
        messageCopy: 'Path copied to clipboard',
        messageCreated: 'Autor erstellt',
        createdAssigned: 'Autor erstellt und mit Nutzer verknüpft',
    },
    channelsApi: {
        notFound: 'Channel nicht gefunden',
        created: 'Channel erstellt',
        pathExists: 'Channel mit diesem Pfad existiert bereits',
        outdated: 'Channeldaten sind veraltet. Aktualisierung fehlgeschlagen',
        updated: 'Channel aktualisiert',
        pathEmpty: 'Pfad darf nicht leer sein',
    },
    channels: {
        basics: 'Basics',
        backButton: 'Zurück',
        settingsLabel: 'Einstellugen',
        settings: 'Channel Erstellen',
        config: 'Konfiguration',
        messageNotSelf: 'Der übergeordnete Channel kann nicht dieser Channel sein',
        messageMandatoryInfo: 'Du kannst den Channel noch nicht speichern, da benötigte Informationen fehlen',
        messageMandatoryInfoConfig: 'Du kannst den Channel noch nicht speichern, da benötigte Informationen in der Channelconfig fehlen',
        messageCreated: 'Channel erstellt',
        messageUpdated: 'Channel aktualisiert',
        name: 'Channel',
        parentChannel: 'Übergeordneter Channel',
        seoTitle: 'SEO-Zeile',
        seoDescription: 'SEO-Beschreibung',
        adTags: 'Werbetags',
        markAsAd: 'Als Werbechannel markieren',
        adsEnabled: 'Werbung aktivieren',
        defaultConfig: 'Standard-Channelkonfiguration nutzen',
        goToChannel: 'zum Channel',
    },
    channelsList: {
        title: 'Channel',
        newButton: 'Neuer Channel',
        search: 'Nach Channelname suchen',
        searchByBrand: 'Nach Marke suchen',
        brand: 'Marke',
        loading: 'Lade Channel',
        headerTitle: 'Titel',
        headerBreadcrumb: 'Breadcrumb/Pfad',
        edit: 'Bearbeiten',
        view: 'Anzeigen',
        mainChannel: 'Hauptchannel',
        childChannel: 'Untergeordneter Channel',
        tooltip: 'Hier können Teaser und Links frei definiert werden, um andere Elemente statt Artikel zu verlinken. Werbliche Angebote sollten mit dem Label "Anzeige" gekennzeichnet werden.',
    },
    channelConfigApi: {
        created: 'Channelkonfiguration erstellt',
        outdated: 'Channelkonfiguration veraltet. Aktualisierung fehlgeschlagen',
        updated: 'Channelkonfiguration aktualisiert',
        notFound: 'Channelkonfiguration nicht gefunden',
    },
    channelConfig: {
        title: 'Channel Titel',
    },
    channelBlock: {
        messageNoNewBlocks: 'Es können keine neuen Blöcke mehr hinzugefügt werden',
        addContent: 'Element hinzufügen',
    },
    channelBlocks: {
        channel: 'Channel',
        premiumOnly: 'Nur Premiumartikel',
        excludedContent: 'Ausgeschlossener Inhalt',
        excludedChannels: 'Ausgeschlossene Channel',
        excludedWeights: 'Ausgeschlossene Gewichtung',
        stageLayout: 'Bühnenlayout',
        standardLayout: 'Standard',
        standardLayoutGrid: 'Standard Grid',
        headlineOneColumnLayout: 'Nur Schlagzeilen einspaltig',
        headlineOnlyLayout: 'Nur Schlagzeilen',
        newstickerLayout: 'Newsticker',
        low: 'Niedrig',
        medium: 'Mittel',
        high: 'Hoch',
        showExceptions: 'Ausnahmen anzeigen',
        hideExceptions: 'Ausnahmen zusammenklappen',
        messageNotEmptyFixed: 'Fixierter Artikel kann nicht leer sein',
        selectArticle: 'Artikel auswählen',
        singleGallery: 'Einzelne Galerie',
        dayGallery: 'Galerie des Tages',
        title: 'Titel',
        kicker: 'Vorzeile',
        link: 'Link',
        label: 'Label',
        leadText: 'Vorspann',
        selectImage: 'Bild auswählen oder hochladen',
        subChannelTags: 'Subchannel Tags',
        listSize: 'Größe der Artikelliste',
        excludedSubchannels: 'Ausgeschlossene Subchannels',
        showPreview: 'Vorschau anzeigen',
        hidePreview: 'Vorschau verstecken',
        newstickerText: 'Der Newsticker zeigt immer die drei zuletzt veröffentlichten Artikel an.',
        loginwallText: 'Nutzer können sich hier registrieren um mehr Inhalte zu sehen. Eingeloggten Benutzern wird dieses Element nicht angezeigt.',
        channelTags: 'Channel Tags',
        teaserTextStandard: 'Zwei bis sechs Teaser. Ein Hauptteaser, der Rest darunter.',
        teaserStandard: 'Standard',
        teaserTextTwoCol: 'Genau fünf Teaser. Ein Hauptteaser, der Rest darunter in zwei Spalten.',
        teaserTwoCol: 'Zwei Spalten',
        bInside: 'Bunte Inside',
        duplicatePlacements: 'Platzierungseinstellungen kopieren',
        duplicatePlacementsMsg: 'Die Platzierungen sind schon vollständig gefüllt.',
        duplicatePlacementsMsg2: 'Bitte lösche eine Platzierung, um die Einstellungen zu duplizieren.',
        messageDuplicateContent: 'Du hast Content mehrfach in der Channelconfig',
        messageNotFiveArticles: 'Es müssen exakt 5 Artikel im Zweispalten-Layout sein',
        messageMinimumArticleCount: 'Es müssen mindestens 2 Artikel im Channel sein',
        topbarText: 'Artikel mit der höchsten Priorität werden in Pilot > Home & Top Bar ausgewählt und in der "Meistgelesen"-Stage angezeigt.',
        performanceOffset: 'Performanceversatz in Stunden',
        messageVideoCount: 'Videoblöcke müssen 3 oder 6 Videos enthalten',
        messageUniqueContent: 'Du hast Content mehrfach im Block',
        messageValidateOffset: 'Performanceversatz muss ein Wert zwischen 0 und 10 sein',
        mainStageText: 'Neuste Artikel mit hoher Priorität werden in Pilot > Home & Top Bar ausgewählt und in der Mainstage angezeigt.',
        personlookText: 'Hier wird der Starlook plaziert. Der Inhalt wird von tracdelight befüllt.',
    },
    cmsUsersApi: {
        emailExists: 'Nutzer mit dieser Emailadresse existiert bereits',
        emailNotFound: 'Emailadresse nicht gefunden',
        updated: 'Nutzer aktualisiert',
        created: 'Nutzer erstellt',
        notFound: 'Nutzer nicht gefunden',
        wrongEmail1: 'Falsche Email oder Passwort (Error code 1)',
        wrongEmail2: 'Falsche Email oder Passwort (Error code 2)',
        accountInvalid: 'Dein Account ist ungültig. Bitte Administrator kontaktieren',
        passwordMissing: 'Bitte zuerst das Passwort setzen. Checke deine Emails für weitere Instruktionen',
        verficationFailed1: '2-Faktor Verifizierung fehlgeschlagen (Error code 1)',
        verficationFailed2: '2-Faktor Verifizierung fehlgeschlagen (Error code 2)',
        tooManyLogins: 'Zu viele Loginversuche. Gesperrt für 1 Stunde',
        tooManyMFATrials: 'Zu viele Zurücksetzungsversuche. Gesperrt für 1 Stunde',
        sessionInvalid: 'Session ungültig',
        sessionDeleted: 'Session gelöscht',
        tokenExpired: 'Token abgelaufen',
        resetPasswortEmailSent: 'Email zum Paswort zurücksetzen versendet',
        passwordInvalid: 'Passwort ungültig',
        messageUserActivated: 'Nutzer reaktiviert',
        messageUserBlocked: 'Nutzer geblockt',
    },
    cmsUsers: {
        backButton: 'Zurück zur Nutzerliste',
        name: 'Name',
        resetPW: 'Passwort zurücksetzen',
        resetPWInfo: 'Es wird eine Email mit Informationen zum Zurücksetzen des Passworts an den Nutzer geschickt',
        reset2FA: '2-FA & Passwort zurücksetzen',
        reset2FAInfo: 'Es wird eine Email mit Informationen zum Zurücksetzen der 2-Faktor Authentifizierung und des Passworts an den Nutzer geschickt',
        saveAndCreate: 'Speichern & Autor erstellen',
        active: 'Aktiv',
        messageMandatoryInformation: 'Du kannst nicht speichern, da dem Nutzer benötigte Informationen fehlen',
        messageUpdated: 'Nutzer aktualisiert',
        messageCreated: 'Nutzer erstellt',
    },
    cmsUsersList: {
        title: 'Nutzer',
        newButton: 'Neuer Nutzer',
        search: 'Name oder E-Mail suchen',
        status: 'Status',
        dpActive: 'Aktiv',
        dpInactive: 'Inaktiv',
        loading: 'Lade CMS Nutzer',
        headerStatus: 'Status',
        headerName: 'Name',
        headerEmail: 'E-Mail',
        headerCreatedAt: 'Erstellt am',
        headerLastLogin: 'Letzter Login',
        dpEdit: 'Bearbeiten',
        dpBlock: 'Blockieren',
    },
    contentSharing: {
        title: 'Contentsharing',
        search: 'Suche',
        showAll: 'Alle anzeigen',
        loading: 'Lade Artikel',
        disclaimer: 'Bitte überprüfe vor dem Importieren von Inhalten, ob die entsprechenden Lizenzen und Berechtigungen vorliegen.',
        headerKickerTitle: 'Vorzeile, Titel',
        headerSource: 'Quelle',
        headerDisplayDate: 'Anzeigedatum',
        dpSelect: 'Auswählen',
        openInNewTab: 'In neuem Tab öffnen',
    },
    galleriesApi: {
        notFound: 'Galerie nicht gefunden',
        updated: 'Galerie aktualisiert',
        created: 'Galerie erstellt',
    },
    galleries: {
        backButton: 'Zurück zur Galerieliste',
        kicker: 'Vorzeile',
        title: 'Hauptzeile',
        saveKeepPublished: 'Speichern & veröffentlicht lassen',
        savePublish: 'Veröffentlichen',
        saveOffline: 'Speichern & offline nehmen',
        saveDraft: 'Als Entwurf speichern',
        settings: 'Einstellungen',
        adsActive: 'Werbung aktiv',
        dayGallery: 'Galerie des Tages',
        publishDate: 'Veröffentlichen am',
        expirationDate: 'Ablaufdatum',
        messageSaveGallery: 'Galerie speichern',
        messageCancel: 'Nein, bleiben',
        messageYesPublish: 'Ja, veröffentlichen',
        messageYesOffline: 'Ja, offline nehmen',
        messageGalleryDay1: 'Galerie',
        messageGalleryDay2: 'Diese Galerie wird als Galerie des Tages eingestellt. Die vorherige Galerie des Tages wird aufgehoben',
        messageGalleryDay3: 'Diese Galerie wird als Galerie des Tages deaktiviert. Es wird keine Galerie des Tages mehr geben',
        messageMandatoryInfo: 'Du kannst die Galerie noch nicht speichern, da benötigte Informationen fehlen',
        messageUpdated: 'Galerie aktualisiert',
        messageCreated: 'Galerie erstellt',
        imageSelectorTitle: 'Bilder und Artikel',
        relatedGalleriesSelectorTitle: 'Ähnliche Bildergalerien',
        preventDayGallery: 'Nur veröffentlichte Galerien können als Galerie des Tages festgelegt werden',
    },
    galleriesList: {
        title: 'Galerien',
        newButton: 'Neue Galerie',
        searchTitleKicker: 'Nach Hauptzeile oder Vorzeile suchen',
        status: 'Galeriestatus',
        loading: 'Lade Galerien',
        dayGallery: 'Galerie des Tages',
        messageNoImages: 'Diese Galerie hat noch keine Bilder',
        deleteGallery: 'Galerie löschen',
        stateAll: 'Alle',
        statePublish: 'Veröffentlicht',
        stateDraft: 'Entwurf',
        stateExpire: 'Depubliziert',
        stateSchedule: 'Geplant',
        headerStatus: 'Status',
        headerKickerTitel: 'KickerTitel',
        headerBilder: 'Bilder',
        headerPreview: 'Vorschau',
        messageConfirmDayGallery1: 'Galerie',
        messageConfirmNotDayGallery2: 'ist nicht mehr als Galerie des Tages ausgewählt',
        messageConfirmDayGallerySwitch2: 'ist als Galerie des Tages ausgewählt und die vorherige Galerie des Tages abgelöst',
        messageConfirmDayGallery2: 'ist als Galerie des Tages ausgewählt',
        messageDayUpdated: 'Galerie des Tages aktualisiert',
        messageDeletedConfirm1: 'Bist du sicher dass du die Galerie',
        messageDeletedConfirm2: 'löschen möchtest?',
        messageDeleted: 'Galerie gelöscht',
        dpEdit: 'Bearbeiten',
        dpDayGallery: 'Als Galerie des Tages auswählen',
        dpDelete: 'Löschen',
        multiSelect: 'Auswählen',
        messageNoSelfLink: 'Galerie kann nicht auf sich selbst verlinken',
    },
    relatedGalleries: {
        addNew: 'Galerie verlinken',
    },
    images: {
        backButton: 'Zurück zur Bilderliste',
        title: 'Titel',
        altText: 'Alt-Text',
        altTextHint: 'Wenn nicht befüllt wird der Titel genutzt',
        caption: 'Bildunterschrift',
        addImage: 'Bild hinzufügen',
        removeImage: 'Bild entfernen',
        source: 'Quelle',
        publishedAt: 'Veröffentlichungsdatum',
        expiredAt: 'Ablaufdatum',
        msn: 'MSN Service',
        deleteImage: 'Bild löschen',
        messageConfirmDelete1: 'Bist du dir sicher, dass du Bild',
        messageConfirmDelete2: 'löschen möchtest?',
        messageMandatoryInformation: 'Du kannst das Bild nicht speichern, da benötigte Informationen fehlen',
        messageUpload: 'Bild hochgeladen',
        messageSaved: 'Bild gespeichert',
        messageDeleted: 'Bild gelöscht',
        invalid: 'Ungültig',
        setFocalPoint: 'Bitte setze den Fokuspunkt, indem du auf das Bild klickst.*',
        articleLabel: 'Artikel',
        invalidVideoCover: 'Abgelaufen',
        invalidVideoCoverTooltip: 'Die Bildvorschau für dieses Video ist abgelaufen.',
        deletedVideoCover: 'Gelöscht',
        deletedVideoCoverTooltip: 'Die Bildvorschau für dieses Video ist gelöscht.',
        messageTooSmall: 'Die Bildauflösung liegt unter der Mindestanforderung von 1200x675 Pixel. Bitte laden Sie ein größeres Bild hoch.',
    },
    pingApi: {
        offline: 'Du bist offline - bitte überprüfe deine Internetverbindung.',
        backOnline: 'Du bist wieder online.',
        softUpdate: 'Es gibt eine neue Version des Editors mit einigen Optimierungen. Um den vollen Funktionsumfang nutzen zu können, lade die Seite bitte zeitnah neu.',
        softUpdateCancel: 'Später',
        forceUpdate: 'Es gibt eine neue Version des Editors mit größeren technischen Veränderungen. Um weiterarbeiten zu können, musst du den Editor neu laden.',
        reload: 'Neu laden',
    },
    libApi: {
        pathArticleExists: 'Es gibt bereits einen Artikel mit diesem Pfad (SEO-Zeile)',
        pathChannelExists: 'Es gibt bereits einen Channel mit diesem Pfad',
        pathAuthorExists: 'Es gibt bereits einen Autor mit diesem Pfad',
        pathPageExists: 'Es gibt bereits eine Seite mit diesem Pfad',
        pathPersonExists: 'Es gibt bereits einen Person mit diesem Pfad',
        pathUnique: 'Der Pfad existiert nur ein mal',
    },
    lockApi: {
        alreadyExists: 'Lock existiert bereits',
        notFound: 'Lock nicht gefunden',
        lockedByOtherUser: 'Bereits von anderem User gelockt',
        lockedByOtherTab: 'Bereits von einem anderen Deiner Browser Tabs gelockt',
    },
    pagesApi: {
        notFound: 'Seite nicht gefunden',
        pathExists: 'Seite mit diesem Pfad existiert bereits',
        created: 'Seite erstellt',
        updated: 'Seite aktualisiert',
    },
    customersApi: {
        notFound: 'Kunde nicht gefunden',
        updated: 'Kunde aktualisiert',
        deleted: 'Kunde gelöscht',
        resetEmailSent: 'Passwort zurücksetzen E-Mail wurde versandt',
        emailNotFound: 'E-Mail Adresse nicht gefunden',
    },
    toplinksApi: {
        notFound: 'Toplink nicht gefunden',
        created: 'Toplink erstellt',
        updated: 'Toplink aktualisiert',
    },
    redirectsApi: {
        notFound: 'Weiterleitung nicht gefunden',
        created: 'Weiterleitung erstellt',
        updated: 'Weiterleitung aktualisiert',
    },
    imagesApi: {
        notFound: 'Bild nicht gefunden',
    },
    pilotApi: {
        notFound: 'Platzierungen nicht gefunden',
        updated: 'Platzierungen aktualisiert',
    },
    peopleApi: {
        notFound: 'Person nicht gefunden',
        alreadyExists: 'Person mit diesem Namen existiert bereits',
        created: 'Person erstellt',
        updated: 'Person aktualisiert',
        pathExists: 'Person kann nicht aktualisiert werden, da der Pfad bereits existiert',
    },
    videosApi: {
        notFound: 'Video nicht gefunden',
    },
    whitelistApi: {
        created: 'Whitelistlink erstellt',
        deleted: 'Whitelistlink gelöscht',
    },
    usersApi: {
        notAuthorized: 'Nicht autorisiert',
        noAccess: 'Kein Zugriff',
        noRightForAction: 'Nutzer ist nicht berechtigt, diese Aktion auszuführen',
        invalidApiToken: 'Ungültiges Token',
        expiredApiToken: 'Abgelaufenes Token',
        signatureErrorApiToken: 'Ungültige Signatur',
        invalidSessionToken: 'Sessiontoken ungültig',
        notFound: 'Nutzer exisitiert nicht',
        notEnabled: 'Benutzer nicht aktiviert. Bitte öffnen Sie ein Ticket, um Zugang zu erhalten.',
        twoFactorMissing: '2-Faktor Authentifizierung nicht eingerichtet',
        unsupportedAuthenticationType: 'Der in der Anfrage angegebene Authentifizierungstyp wird von der API nicht unterstützt',
    },
    videosList: {
        title: 'Videos',
        newButton: 'Neues Video',
        multi: 'Ausgewählte Videos hinzufügen',
        search: 'Nach Hauptzeile oder Videounterschrift suchen',
        status: 'Videostatus',
        dpAll: 'Alle',
        statusActive: 'Veröffentlicht am',
        statusInactive: 'Depubliziert',
        statusSchedule: 'Geplant am',
        date: 'Erstellungsdatum',
        credits: 'Videoquelle',
        uuid: 'Video UUID',
        noVideos: 'Entschuldigung, wir haben keine Videos gefunden, die den ausgewählten Kriterien entsprechen',
        contentId: 'Xymatic-ID',
    },
    linkWhitelist: {
        info: 'Links zu diesen Domains werden nicht als “nofollow” gesetzt',
        newLink: 'Neuer Link',
        url: 'Nach URL suchen',
        loading: 'Lade Link Whitelist',
        messageTitle: 'Whitelistlink löschen',
        messageMsg: 'Bist du dir sicher, dass du den Link löschen möchtest?',
        newWLLink: 'Neuer Whitelistlink',
        headerLink: 'Link',
        headerCreated: 'Erstellt am',
        backButton: 'Zurück',
        title: 'Whitelist link erstellen',
        path: 'URL',
        actionButtonLabel: 'Ja, ENTFERNEN',
        cancelButtonLabel: 'Abbrechen ',
    },
    pages: {
        backButton: 'Zurück',
        content: 'Inhalt',
        preview: 'Vorschau',
        saveKeepPublished: 'Speichern & veröffentlicht lassen',
        savePublish: 'Speichern & Veröffentlichen',
        saveOffline: 'Speichern & offline nehmen',
        saveDraft: 'Als Entwurf speichern',
        unpublish: 'Seite offline nehmen',
        delete: 'Seite löschen',
        changeContent: 'Textformat geändert',
        changeContentMsg: 'Das Textformat wurde verändert. Das könnte Content entfernen, welcher in diesem Format nicht unterstützt werden. Bist du dir sicher, dass du die Änderungen speichern möchtest?',
        messageConfirmUnpublish1: 'Bist du dir sicher, dass du die Seite',
        messageConfirmUnpublish2: 'offline nehmen möchtest?',
        messageConfirmDelete2: 'löschen möchtest?',
        messageMandatoryInformation: 'Du kannst die Seite nicht speichern, da benötigte Informationen fehlen',
        messageCreated: 'Seite erstellt',
        messageUpdated: 'Seite aktualisiert',
        messageDeleted: 'Seite löschen',
    },
    pagesEdit: {
        title: 'Titel',
        showTitle: 'Titel anzeigen',
        styling: 'Standardstyling verwenden',
        author: 'Autor',
        createdDate: 'Erstellt am',
        changeDate: 'Bearbeitet am',
        path: '/',
        settings: 'Einstellungen',
    },
    pagesList: {
        title: 'Seiten',
        newButton: 'Neue Seite',
        search: 'Name',
        status: 'Status',
        dpPublished: 'Veröffentlicht',
        dpPreview: 'Offline',
        loading: 'Lade Seiten',
        delete: 'Seite löschen',
        headerStatus: 'Status',
        headerTitle: 'Titel',
        headerUrl: 'URL',
        dpEdit: 'Bearbeiten',
        dpDelete: 'Seite löschen',
        noUrl: 'Seitenurl nicht verfügbar',
        messageConfirmDelete1: 'Bist du dir sicher, dass du die Seite',
        messageConfirmDelete2: 'löschen möchtest?',
        messageDeleted: 'Seite gelöscht',
    },
    customers: {
        backButton: 'Zurück zur Kundenliste',
        id: 'Kunden-ID',
        email: 'Email',
        salutation: 'Anrede',
        firstname: 'Vorname',
        lastname: 'Nachname',
        birth: 'Geburtsdatum',
        street: 'Straße',
        streetNr: 'Hausnummer',
        postcode: 'Postleitzahl',
        city: 'Stadt',
        country: 'Land',
        resetPW: 'Passwort zurücksetzen',
        resetPWHint: 'Neues Password wird zum Nutzer geschickt',
        createdAt: 'Erstellungsdatum',
        confirmedAt: 'Bestätigungsdatum',
        lastLogin: 'Letzter Login',
        lastChange: 'Letzte Änderung',
        phone: 'Telefonnummer',
        subscriptionId: 'Abonnementplan ID',
        subscriptionStatus: 'Abonnementstatus',
        subscriptionCreated: 'Abonnement Erstellungsdatum',
        subscriptionNextBilling: 'Nächstes Abonnement Abrechnungsdatum',
        mr: 'Herr',
        mrs: 'Frau',
        de: 'Deutschland',
        at: 'Österreich',
        ch: 'Schweiz',
        availableHearts: 'Verfügbare Herzen',
        redeemedHearts: 'Eingelöste Herzen',
        totalHearts: 'Herzen insgesamt',
        lVideo: 'Video',
        lArticle: 'Artikel',
        lRegister: 'Registrierung',
        lShare: 'Teilen',
        lSpecial: 'Spezial',
        lNewsletter: 'Newsletter',
        lSurvey: 'Umfrage',
        messageMandatoryInformation: 'Du kannst den Nutzer nicht speichern, da benötigte Informationen fehlen',
        messageUpdated: 'Kunde aktualisiert',
        messageResetPw: 'Link zum Passwort zurücksetzen gesendet',
    },
    customersList: {
        title: 'Kundenliste',
        search: 'Kunde suchen',
        createdRange: 'Erstellungszeitraum',
        status: 'Kundenstatus',
        statusRegistered: 'Registriert',
        statusConfirmed: 'Bestätigt',
        lastLoginRange: 'Login-Zeitraum',
        subStatus: 'Abonnementstatus',
        none: 'Keiner',
        active: 'Aktiv',
        trial: 'Testabo',
        nonRenew: 'In Kündigung',
        cancelled: 'Gekündigt',
        loading: 'Lade Kunden',
        delete: 'Kunde löschen',
        headerFName: 'Vorname',
        headerLName: 'Nachname',
        headerEmail: 'Email',
        headerCreatedAt: 'Erstellt am',
        headerLastLogin: 'Letzter Login',
        headerSubStatus: 'Abo-Status',
        headerStatus: 'Kundenstatus',
        headerHearts: 'Verfügbare Herzen',
        messageDelete: 'Bist du dir sicher, dass du den Kunden löschen möchtest?',
        messageDeleted: 'Kunde gelöscht',
        dpEdit: 'Bearbeiten',
        dpDelete: 'Löschen',
        cannotDelete: 'Ein Kunde mit einem aktiven Abonnement kann nicht gelöscht werden',
    },
    homeTopBar: {
        aPlacement: 'Artikelplatzierung',
        aPlaced1: 'Artikel ist schon auf',
        aPlaced2: 'platziert',
        hMainTitle: 'Main Stage (Home)',
        hTBTitle: 'Top Bar (Meistgelesen)',
        hSavePublish: 'Speichern & Veröffentlichen',
        hAlreadyMainStage: 'Artikel ist schon auf der Main Stage (Home) platziert',
        hAlreadyTopBar: 'Artikel ist schon auf der Top Bar (Meistgelesen) platziert',
        hMainMin: 'Main Stage (Home) muss mindestens 4 Artikel enthalten',
        hMainMax: 'Main Stage (Home) kann maximal 5 Artikel enthalten',
        hTB5: 'Top Bar (Meistgelesen) muss 5 Artikel enthalten',
        hMessageUpdated: 'Platzierungen aktualisiert',
        qSearch: 'Suche',
        qNoResults: 'Keine Ergebnisse gefunden',
        title: 'Du hast deine Änderungen nicht gespeichert',
        message: 'Möchtest du die Änderungen verwerfen ?',
    },
    redirectsList: {
        title: 'Weiterleitung',
        newButton: 'Neue Weiterleitung',
        search: ' Nach Weiterleitung suchen',
        loading: 'Lade Weiterleitung',
        delete: 'Weiterleitung löschen',
        headerFrom: 'Von',
        headerTo: 'Nach',
        messageDelete: 'Bist du dir sicher, dass du die Weiterleitung löschen möchtest?',
        messageDeleted: 'Weiterleitung gelöscht',
        dpEdit: 'Bearbeiten',
        dpDelete: 'Löschen',
    },
    redirects: {
        basics: 'Erstellen',
        backButton: 'Zurück',
        from: 'Von',
        to: 'Nach',
        messageMandatoryInformation: 'Du kannst die Weiterleitung nicht speichern, da benötigte Informationen fehlen',
        messageUpdated: 'Weiterleitung aktualisiert',
        messageCreated: 'Weiterleitung erstellt',
        btnMessageCancel: 'Abbrechen',
        btnMessageConfirm: ' Ja, ENTFERNEN',
    },
    topLinksList: {
        title: 'Toplinks',
        newButton: 'Neuer Toplink',
        loading: 'Lade Toplinks',
        delete: 'Link löschen',
        headerName: 'Name',
        headerPath: 'Pfad',
        messageDelete1: 'Bist du sicher, dass du den Link',
        messageDelete2: 'löschen willst?',
        messageDeleted: 'Link gelöscht',
        dpEdit: 'Bearbeiten',
        dpDelete: 'Löschen',
    },
    topLinks: {
        backButton: 'Zurück',
        name: 'Name',
        path: 'Pfad',
        messageMandatoryInformation: 'Du kannst den Toplink nicht speichern, da benötigte Informationen fehlen',
        messageUpdated: 'Toplink aktualisiert',
        messageCreated1: 'Toplink',
        messageCreated2: 'erstellt',
        basics: 'TopLink Erstellen',
        actionButtonLabel: ' Ja, ENTFERNEN',
        cancelButtonLabel: ' Abbrechen',
    },
    resetPW: {
        select: 'Passwort auswählen',
        '2faCode': '2 Faktor Authentifizierungscode',
        '2faDesc': 'Bitte scanne diesen QR-Code mit deiner Microsoft oder Google Authenticator App. Du muss danach einen 2. Code beim Login eingeben.',
        '2fa': '2 Faktor Token',
        continue: 'Weiter',
        messageNoChangeTitle: 'Der Link ist abgelaufen.',
        messageNoChange: 'Mit diesem Link kannst du dein Passwort nicht mehr ändern. Bitte fordere ein neues Passwort über den Zurücksetzen-Link an.',
        match: 'Passwörter müssen übereinstimmen',
    },
    peopleList: {
        title: 'Personen',
        newButton: 'Neue Person',
        search: 'Nach Name suchen',
        ranking: 'Ranking',
        loading: 'Lade Personen',
        headerName: 'Name',
        headerBirth: 'Geburtsdatum',
        headerPicture: 'Bild',
        headerSimilar: 'Ähnliche Personen',
        dpEdit: 'Bearbeiten',
        dpShow: 'Anzeigen',
        multiLabel: 'Personen auswählen',
        multiSelect: 'Auswählen',
    },
    people: {
        name: 'Anzeigename',
        firstName: 'Vorname',
        lastName: 'Nachname',
        male: 'männlich',
        female: 'weiblich',
        zodiacSign: 'Sternzeichen',
        birth: 'Geburtsdatum',
        dateDeath: 'Todestag',
        placeBirth: 'Geburtsort',
        size: 'Größe (cm)',
        bioShort: 'Kurzbiographie',
        bio: 'Biographie',
        picture: 'Hauptbild auswählen oder hochladen',
        ranking: 'Ranking',
        messageMandatoryInformation: 'Du kannst den Person nicht speichern, da benötigte Informationen fehlen',
        messageUpdated: 'Person aktualisiert',
        messageCreated: 'Person erstellt',
        aries: 'Widder',
        taurus: 'Stier',
        gemini: 'Zwillinge',
        cancer: 'Krebs',
        leo: 'Löwe',
        virgo: 'Jungfrau',
        libra: 'Waage',
        scorpio: 'Skorpion',
        sagittarius: 'Schütze',
        capricorn: 'Steinbock',
        aquarius: 'Wassermann',
        pisces: 'Fische',
        userRole: 'Nutzerrolle',
        relatedPeople: 'Ähnliche Personen',
        settings: 'Einstellungen',
    },
    video: {
        channel: 'Channel',
        published: 'Veröffentlicht',
        liveFrom: 'Live seit',
        expiredAt: 'Läuft ab am',
        title: 'Video',
        search: 'Nach Titel oder Vorzeile suchen',
        contentId: 'Xymatic-ID',
        mode: 'Videostatus',
        all: 'Alle',
        unpublished: 'Offline',
        uuid: 'Video UUID',
        premium: 'Inside Video',
        noVideo: 'Wir konnten keine Videos finden, die deinen Kriterien entsprechen.',
        providers: 'Anbieter',
    },
    locks: {
        lockedBy: 'Der Inhalt ist gesperrt von:',
        break: 'Entsperren',
        lockedByYou: 'Der Inhalt ist von dir selbst in einem anderen Tab gesperrt',
        lockRemoved: 'Sperre wurde entfernt',
        contentChanged: 'Der Inhalt wurde extern verändert. Dein Inhalt kann in diesem Tab nicht mehr gespeichert werden.',
        refresh: 'Aktualisieren',
    },
    validation: {
        required: 'Benötigt',
        minLength1: 'Muss mindestens',
        minLength2: 'Buchstaben enthalten',
        maxLength1: 'Darf nicht mehr als',
        maxLength2: 'Zeichen enthalten',
        exactLengthNumber1: 'Bitte genau',
        exactLengthNumber2: 'Zahlen eingeben',
        containNumber: 'Muss eine Zahl enthalten',
        containLowercase: 'Muss einen Kleinbuchstaben enthalten',
        containUppercase: 'Muss einen Großbuchstaben enthalten',
        validEmail: "Muss eine Email sein (z.B.: test{'@'}test.test)",
        validPath: 'Muss eine valide URL sein (z.B.: /valid-url) und darf keine Sonderzeichen enthalten',
        validDate: 'Muss eine valide Datum sein: dd.mm.yyyy (z.B.: 14.04.2006)',
        validDateTime: 'Muss eine valide Datum und Zeit sein: dd.mm.yyyy dd.mm.yyyy hh:mm (z. B.: 14.04.2006 15:03)',
        validDateNotInFuture: 'Darf kein Datum in der Zukunft sein',
        notContainHTML: 'Sollte nicht ".html" enthalten',
        isNumeric: 'Muss eine Zahlenkombination sein',
        isRelativePath: 'Pfad muss mit / beginnen',
        lessThan11: 'Muss ein Wert zwischen 0 und 10 sein',
        lessThanNumber: 'Muss ein Wert zwischen 0 und {number} sein',
        validURL: 'Muss ein valider Link sein',
        higherEqual0: 'Muss eine Zahl sein, die 0 oder höher ist',
        validBrandUrl: 'Muss eine valide {brand} URL sein',
        exactNumber: 'Muss genau {number} sein',
        evenNumber: 'Muss eine gerade Zahl sein',
        multipleOfNumber: 'Muss ein Vielfaches von {number} sein',
        moreThan: 'Muss gleich oder größer als {number} sein',
        lessThan: 'Muss gleich oder kleiner als {number} sein',
        validPublishState: 'Muss ein valider Veröffentlichungsstatus sein',
    },
    listView: {
        filterDelete: 'Filter löschen',
        filter: 'Filter',
        more: 'Mehr',
        less: 'Weniger',
    },
    blockLabel: {
        login: 'Login',
        main: 'Main-Channel-Stage',
        subchannel: 'Channel-Stage',
        video: 'Video-Stage',
        custom: 'Script',
        topbar: 'Topbar/Meistgelesen',
        fixed: 'Fixierter Artikel',
        flex: 'Auto Artikel',
        teaser: 'Linkout Teaser',
        fixedVideo: 'Fixiertes Video',
        performerVideo: 'Performance Video',
        latestVideo: 'Neustes Video',
        gallery: 'Galerie',
        newsletter: 'Newsletter Box',
        dayGallery: 'Galerie des Tages',
        newsticker: 'Newsticker',
        mainStage: 'Main-Stage',
        starlook: 'Starlook',
        more: 'Mehr zum Thema',
        channelTopbar: 'Channel Topbar',
        homepage: 'Homepage Block',
    },
    components: {
        articleSource: 'Artikelquelle',
        channelSelectorLabel: 'Channel',
        personSelectorLabel: 'Ähnliche Personen',
        bfJob: 'Team',
        contentPartner: 'Content Partner',
        noPartner: 'Kein Partner',
        gTopNews: 'SCHLAGZEILEN',
        gDiscover: 'DISCOVER',
        hourAgo: 'vor 1 Stunde',
        bunteHour: 'Bunte 1 std.',
        gNewsSearch: 'NEWS SUCHE',
        gNewsApp: 'NEWS APP',
        yesterday: 'Gestern',
        articleSwitch: 'Artikel austauschen',
        articleSelect: 'Artikel auswählen',
        authorSelect: 'Autor',
        authorInactive: 'Inaktiv',
        articleInvalid: 'Artikel ist ungültig',
        previewMobile: 'Mobil',
        previewTablet: 'Tablet',
        previewDesktop: 'Desktop',
        previewAMP: 'AMP',
        previewApp: 'App',
        previewGoogle: 'Google',
        previewPageInvalid: 'Seite ungültig',
        previewArticleInvalid: 'Artikel ungültig',
        block: 'Blockieren',
        reactivate: 'Reaktivieren',
        useAsDayGallery: 'Als Galeries des Tages verwenden',
        notUseAsDayGallery: 'Nicht mehr als Galerie des Tages verwenden',
        imageUploadLabel: 'Wähle oder lade ein Bild hoch. {maxFileSize}MB Limit',
        imageSelectorHintInvalid: 'ungültiges Bild',
        imageSelectorHintUnknown: 'unbekannter Fehler',
        uploadImage: 'Bild hochladen',
        editImage: 'Bild bearbeiten',
        selectVideo: 'Video auswählen',
        selectGallery: 'Galerie auswählen',
        fieldRequired: 'Dieses Feld wird benötigt',
        selectUploadImage: 'Bild auswählen oder hochladen',
        newsletterKind: 'Art des Newsletters',
        password: 'Passwort',
        blockRemoveTitle: 'Block entfernen',
        blockRemoveDescription: 'Möchten Sie diesen Block wirklich entfernen?',
        low: 'Niedrig',
        medium: 'Mittel',
        high: 'Hoch',
        urlSettings: 'URL Einstellungen',
        date: 'Datum',
        time: 'Uhrzeit',
        fullHTML: 'Auf vollständiges HTML umschalten',
        noRichTextEditor: 'Der Rich-Text-Editor ist nicht verfügbar, da der Inhalt Tags (z. B. "script") enthält, die nicht unterstützt werden. Durch Aktivieren könnten Daten verloren gehen.',
        useAnyway: 'Rich-Text-Editor trotzdem nutzen',
        fullHTMLScriptCode: 'Volles HTML oder Script Code hier einfügen',
        people: 'People',
        articles: 'Artikel',
        channels: 'Channel',
        noFollow: 'Nofollow',
        markAffiliate: 'Als Affiliate markieren',
        newTab: 'In neuem Tab öffnen',
        paragraph: 'Fließtext',
        heading2: 'Überschrift 2',
        heading3: 'Überschrift 3',
        imageSelect: 'Auswählen',
        imageSelected: 'Ausgewählt',
        imageExpiresIn: 'Läuft in {n} Tagen ab',
        imagePublish: 'Online in {n} Tagen',
        imageExpired: 'Abgelaufen',
        imageExpires: 'Läuft ab',
        imageCreated: 'Erstellt',
        imageTitle: 'Titel',
        imageCredits: 'Quelle',
        imageStatus: 'Status',
        aspectText: 'Vorschau für verschiedene Bildgrößen basierend auf dem Fokuspunkt',
        aspectTeaser: 'Teaser Home & Channel + Titelbild Mobile',
        aspectTitle: 'Titelbild auf Tablet & Desktop',
        aspectDesc: 'Wenn der Fokuspunkt gesetzt wird, ist die Vorschau nach dem Speichern hier sichtbar.',
        aspectClick: 'Bitte auf das quadratische Bild fokusieren',
        videoPreviewPlay: 'Videovorschau',
        videoPreviewClose: 'Videovorschau schließen',
        imageDeleted: 'Gelöscht',
    },
    newsletter: {
        inside: 'Wöchentlich die besten BUNTE inside Themen per E-Mail',
        portal: 'Die beliebtesten News des Tages per E-Mail',
        royals: 'Der wöchentliche Newsletter aus der Adelsredaktion',
        family: 'Wöchentliche Tipps für alle Lebenslagen per E-Mail',
        health: 'Deine wöchentlichen News für ein gesundes Leben',
        deals: 'Die besten BUNTE.de Deals der Woche',
        aktionen: 'Exklusive Angebote, Gewinnspiele, Gutscheine und Stories nur für dich',
    },
};
//# sourceMappingURL=de.js.map